module.exports = " <div class=\"reservations-table-collapse-body clearfix\"> <slot name=title> <div class=-row v-bind:style=rowStyle> <div v-for=\"t in ticks\" class=-cell v-bind:style=cellStyleByTick(t) @mouseover=\"$dispatch('tick-over', t)\" @mouseout=\"$dispatch('tick-out', t)\"></div> </div> </slot> <slot v-if=!isCollapsed></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/reservations/reservations-table/row/collapse/body.vue
// module id = 251
// module chunks = 0